import { render, staticRenderFns } from "./AdminSpecialOfferReceipt.vue?vue&type=template&id=c4d95804&scoped=true&"
import script from "./AdminSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
export * from "./AdminSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSpecialOfferReceipt.vue?vue&type=style&index=0&id=c4d95804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d95804",
  null
  
)

export default component.exports